import { useQuery } from '@tanstack/react-query';
import { listAttributeDefinitions } from '@/api/attributeDefs';

/**
 * Cache the dictionary aggressively — it changes only when an admin
 * publishes a new attribute. A 5-minute staleTime mirrors the backend's
 * own in-process cache and keeps the UI snappy when several pages need
 * the same data.
 */
export function useAttributeDefs() {
  return useQuery({
    queryKey: ['attribute-definitions'],
    queryFn: listAttributeDefinitions,
    staleTime: 5 * 60_000,
  });
}
